import { useRoute } from 'vue-router'

export default function useOpenApp(schemaPrefix = 'envo://launch') {
  const route = useRoute()

  const openApp = () => {
    if (route.query.channelCode) {
      wakeupOrInstall();
    } else {

      const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent)
      const params = route.fullPath.split('?')[1]
      const schema = params ? `${schemaPrefix.replace(/\/$/, '')}/?${params}` : schemaPrefix
      if (isSafari) {
        const link = document.createElement('a')
        link.href = schema
        link.style.display = 'none'
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
      } else {
        window.location = schema as unknown as Location
      }
    }
  }

  let openInstall: any;
  // 直接拉起
  const schemeWakeup = () => {
    let res = openInstall.schemeWakeup({ data: route.query, channelCode: route.query.channelCode });
    console.log(res, "resresres");
  };
  // 安装
  const wakeupOrInstall = () => {
    openInstall.wakeupOrInstall({ data: route.query, channelCode: route.query.channelCode });
  };
  const initOpeninstall = () => {
    if (!route.query.channelCode) return;
    const s = document.createElement("script");
    s.type = "text/javascript";
    s.src = "//web.cdn.openinstall.io/openinstall.js";
    s.addEventListener(
      "load",
      () => {
        var data = window.OpenInstall.parseUrlParams(); //解析获取参数
        console.log(data, "datadatadata");
        openInstall = new window.OpenInstall(
          {
            appKey: "d0g5y4",//根据自己项目配置
            //apkFileName : 'xx.apk',//自定义下载时的apk包名
            preferWakeup: true,
            channelCode: route.query.channelCode,
            mask: function () {
              return;
              ("<div  id='openinstall_shadow'style='position:fixed;left:0;top:0;background:rgba(0,255,0,			0.5);filter:alpha(opacity=50);width:100%;height:100%;z-index:10000;'></div>");
            }, //自定义打开时的遮罩样式
            //openinstall初始化完成的回调函数，可选
            onready: function () {
              schemeWakeup()
            },
          },
          data
        );
      },
      false
    );
    document.head.appendChild(s);
  }
  if (route.query.channelCode) {
    initOpeninstall();
  }
  return {
    openApp,
  }
}
